export default __webpack_public_path__ + "static/media/img14.25c99476.png";